(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !window.DesignMode) return;
  try {
    
  console.log("loading hero 1")
 $( document ).ready(function() {
    console.log("loading hero 2")
     var end = new Date('05/23/2024 9:00 AM');
  
      var _second = 1000;
      var _minute = _second * 60;
      var _hour = _minute * 60;
      var _day = _hour * 24;
      var timer;
  
      function showRemaining() {
          var now = new Date();
          var distance = end - now;
          if (distance < 0) {
  
              clearInterval(timer);
              $(".countdown_card" ).empty();
              $(".countdown_card" ).append( 'EXPIRED!' );
            $(".clockbanner").hide();
              return;
          }
          var days = Math.floor(distance / _day);
          var hours = Math.floor((distance % _day) / _hour);
          var minutes = Math.floor((distance % _hour) / _minute);
          var seconds = Math.floor((distance % _minute) / _second);

        console.log("empty card");
          $(".countdown_card" ).empty();
        
          $( "#days" ).append( days + '<div class="card_sub">days</div>' );
          $( "#hours" ).append( hours + '<div class="card_sub">hours</div>' );
          $( "#mins" ).append( minutes + '<div  class="card_sub">minutes</div>' );
          $( "#secs" ).append( seconds + '<div  class="card_sub">seconds</div> ' );
      }
  
      timer = setInterval(showRemaining, 1000);
});


  } catch(e) { console.error(e); }
})();
})();
